import { render } from "./HaircolorTreatProductTile.vue?vue&type=template&id=7b93b312"
import script from "./HaircolorTreatProductTile.vue?vue&type=script&lang=js"
export * from "./HaircolorTreatProductTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__